import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { isEmpty, isNaN } from 'lodash';
import { SFEntityID } from 'utils/types';

export default class DecimalFilterPanel extends React.Component {
  static defaultProps = {
    value: {},

    operators: [{
      text: 'Equal To',
      value: '='
    }, {
      text: 'Greater Than or Equal To',
      value: '>='
    }, {
      text: 'Less Than or Equal To',
      value: '<='
    }]
  };

  constructor(props) {
    super(props);

    this.state = {
      operator: "="
    };
  }

  onOperatorChange = (e, operatorData) => {
    const number = !isEmpty(this.props.value) ? this.props.value.number : '';
    this.setState({ operator: operatorData.value });
    this.updateSelection(operatorData.value, number);
  };

  onNumberChange = (e, numberData) => {
    const rawNumber = parseFloat(numberData.value);
    const number = isNaN(rawNumber) ? '' : rawNumber.toFixed(2);
    const operator = !isEmpty(this.props.value) ? this.props.value.operator : this.state.operator;
    this.updateSelection(operator, number);
  };

  updateSelection = (operator, number) => {
    if (!isEmpty(number)) {
      this.props.addSelection({
        questionId: this.props.question.id,
        type: this.props.question.type,
        value: {
          number: number,
          operator: operator
        }
      });
    } else {
      this.props.removeSelection(this.props.question.id);
    }
  }

  handleFormSubmit = (e) => {
    e.preventDefault();
    if (!this.props.onSubmit) {
      return;
    }

    this.props.onSubmit();
  };

  render() {
    return (
      <Form onSubmit={this.handleFormSubmit}>
        <Form.Select
          options={this.props.operators}
          defaultValue={isEmpty(this.props.value) ? this.state.operator : this.props.value.operator}
          disabled={!this.props.enabled}
          onChange={this.onOperatorChange} />
        <Form.Input
          placeholder="Enter a number"
          type="number"
          step="1"
          value={isEmpty(this.props.value) ? '' : this.props.value.number}
          disabled={!this.props.enabled}
          onChange={this.onNumberChange} />
      </Form>
    );
  }
}

DecimalFilterPanel.propTypes = {
  question: PropTypes.shape({
    id: SFEntityID.isRequired,
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }),
  value: PropTypes.shape({
    number: PropTypes.string,
    operator: PropTypes.string
  }),
  enabled: PropTypes.bool.isRequired,

  onSubmit: PropTypes.func,
  addSelection: PropTypes.func.isRequired,
  removeSelection: PropTypes.func.isRequired,
  operators: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }))
};
